module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"Overview":"総括","Overviewtooltip":"選択期間、比較期間中の来店客数を表示しています。また、今日から7日間先の来店客数の予測を表示しています。","tooltip":"総括"}}')
  delete Component.options._Ctor
}
